import { useEffect, useRef, useState } from "react";
import { Field, ErrorMessage } from "formik";
import TextError from "../textError";
import {
  Container,
  Element,
  Wrapper,
} from "./index.styled";

export default function Input({
  name,
  type,
  placeholder,
  label,
  leftIcon = false,
  rightIcon = false,
  toggleType = false,
  borderColor="#BBB",
  // width = "404px",
  // height = "56px",
  
  // fontColor = "#0f0f0f",
  // placeholderColor = "#27548c",
  // minHeight="95px",
}) {
  const inputElement = useRef();
  const [errorMode, setErrorMode] = useState(false);
  const [inputType, setInputType] = useState(type);

  useEffect(() => {
    if (errorMode) {
      inputElement.current.style.border = "1px solid #FF3D3D";
    } else {
      inputElement.current.style.border = `1px solid ${borderColor}`;
    }
  }, [errorMode]);

  const handleToggleType = () => {
    if (inputType === "password") {
      setInputType("text");
    } else {
      setInputType("password");
    }
  };

  return (
    <Field name={name}>
      {({ field, meta }) => (
        <Wrapper>
          <Container ref={inputElement}>
         
            <Element
              leftIcon
              rightIcon
              type={inputType}
              placeholder={placeholder}
              {...field}
             
              background="transparent"
            />
          
          </Container>
          <ErrorMessage component={TextError} name={name} />
          {meta.touched && meta.error
            ? setErrorMode(true)
            : setErrorMode(false)}
        </Wrapper>
      )}
    </Field>
  );
}
